import {
    DOWNLOAD_SETTLEMENT_CSV,
    DOWNLOAD_SETTLEMENT_CSV_FAILURE,
    DOWNLOAD_SETTLEMENT_CSV_SUCCESS,
    GETTING_SETTLEMENT_ACCOUNT,
    GETTING_SETTLEMENT_ACCOUNT_FAILURE,
    GETTING_SETTLEMENT_ACCOUNT_SUCCESS,
    GET_SETLLEMENTS_ANALYTICS,
    GET_SETLLEMENTS_ANALYTICS_FAILURE,
    GET_SETTLEMENTS_ANALYTICS_SUCCESS,
    GET_SETTLEMENT_TRANSACTION_SUCCESS,
    GET_UNSETTLED_SETTLEMENTS,
    GET_UNSETTLED_SETTLEMENTS_FAILURE,
    GET_UNSETTLED_SETTLEMENTS_SUCCESS,
    SET_ALL_PAYOUTS,
    SET_SINGLE_PAYOUTS
} from './actionTypes';

const initialState = {
    allPayouts: null,
    singlePayout: null,
    gettingSettlementAccount: false,
    gettingSettlementAccountSuccess: {},
    gettingSettlementAccountFailure: '',
    settlementTransaction: null,
    settlementSummary: null,
    loading: false,
    summaryError: null,
    downloadError: null,
    downloaded: null
};

const Payouts = (state = initialState, action) => {
    switch (action.type) {
        case SET_SINGLE_PAYOUTS:
            state = { ...state, singlePayout: action.payload };
            break;
        case SET_ALL_PAYOUTS:
            state = { ...state, allPayouts: action.payload };
            break;
        case GETTING_SETTLEMENT_ACCOUNT:
            return { ...state, gettingSettlementAccount: true };
        case GETTING_SETTLEMENT_ACCOUNT_SUCCESS:
            return { ...state, gettingSettlementAccount: false, gettingSettlementAccountSuccess: action.payload };
        case GETTING_SETTLEMENT_ACCOUNT_FAILURE:
            return {
                ...state,
                gettingSettlementAccount: false,
                gettingSettlementAccountSuccess: null,
                gettingSettlementAccountFailure: action.payload
            };
        case GET_SETTLEMENT_TRANSACTION_SUCCESS:
            return { ...state, settlementTransaction: action.payload };
        case GET_SETLLEMENTS_ANALYTICS:
            return { ...state, loading: true };
        case GET_SETLLEMENTS_ANALYTICS_FAILURE:
            return { ...state, summaryError: action.payload, loading: false };
        case GET_SETTLEMENTS_ANALYTICS_SUCCESS:
            return { ...state, settlementSummary: action.payload, loading: false };
        case GET_UNSETTLED_SETTLEMENTS:
            return { ...state, loading: true };
        case GET_UNSETTLED_SETTLEMENTS_SUCCESS:
            return { ...state, allPayouts: action.payload, loading: false };
        case GET_UNSETTLED_SETTLEMENTS_FAILURE:
            return { ...state, loading: false };
        case DOWNLOAD_SETTLEMENT_CSV:
            return { ...state, loading: true };
        case DOWNLOAD_SETTLEMENT_CSV_FAILURE:
            return { ...state, loading: false, downloadError: action.payload };
        case DOWNLOAD_SETTLEMENT_CSV_SUCCESS:
            return {...state, loading: false, downloaded: action.payload}
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default Payouts;
